import classes from "./Introduction.module.css";
import React, { useEffect, useContext, useState } from "react";
import { images } from "../../assets/img";
import BookNowBtn from "../BookNowBtn";
import RemoteConfig from "../../services/RemoteConfig";
import AuthContext from "../../store/auth-context";
import { NAIL_SHOP_INFO } from "../../utils/Const";
import useCheckIsMobile from "../../hook/useCheckIsMobile";
import MainCarousel from "../Carousel/Carousel";
import InstagramFeed from "../InstagramFeed/InstagramFeed";

const Introduction = (props) => {
  const { introductionRef } = props || {};
  const isMobile = useCheckIsMobile();

  return (
    <div ref={introductionRef} className={classes.container}>
      <div className={classes.introduction}>
        <div className={classes.textContainer}>
          <h1>{`Feel Your Best, Right Here in Edinburgh\n`}</h1>
          <h4>
            {`At our Edinburgh salon, we combine expert nail care with a calm, stylish space to help you relax and feel refreshed.\nFrom detailed manicures and soothing pedicures to stunning nail enhancements,\nwe use quality products to keep your nails looking their best — strong, healthy, and beautiful.`}
          </h4>
          <BookNowBtn />
        </div>

        <div
          style={{
            borderBottomLeftRadius: "100%",
            borderBottomRightRadius: "100%",
          }}
        >
          <img
            className={classes.imageStyle}
            alt={"Introduction"}
            src={images.banner03}
          />
        </div>
      </div>
      <InstagramFeed />

      <div className={classes.contactStaffContainer}>
        <div className={classes.wrapperStyling}>
          <h1>Talk to our staff</h1>
          <h4 style={{marginTop:'2vh',marginBottom: '4vh'}}>
            Our friendly and knowledgeable team at Beauty Boutique Nails is here to assist
            you with any questions or recommendations. Whether you’re looking
            for advice on the perfect nail treatment or need help choosing a
            color, our staff is always ready to provide personalized care and
            ensure your experience is exceptional.
          </h4>
          <BookNowBtn style={classes.bookNowBtnStyle}/>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
